import { AxiosResponse } from 'axios';
import cacheableRequest from '../../../services/cacheableRequest';
import { Training } from '../models/training';

export const getTrainingSearchResult = (trainingId: string): Promise<Training> => {
  return cacheableRequest(`/v1/search/${trainingId}`).then(({ data }: AxiosResponse<Training>) => {
    return data;
  });
};
